import { Component, OnInit, OnDestroy, ViewChild, HostListener, NgZone, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from "@angular/material/snack-bar";
import { ReferrerPortalService } from '../referrer-portal.service';
import moment from 'moment';
import { StaticDataService } from 'src/app/services/static-data.service';
import { TdoTableSelectionEvent } from 'src/app/tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { ReferralDataModel } from '../../configuration/referral-configuration/models/referral-data.model';
import { FormatPhoneNumberPipe, FormatPhonePipe } from 'src/app/pipes/format-phone.pipe';
import { DiscomfortLevelList } from 'src/app/constants';
import { ToastrService } from 'ngx-toastr';
import { Sort } from '@angular/material/sort';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { TdoTableV2Component } from 'src/app/tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import { TdoSearchEvent } from 'src/app/tdo-controls/common/tdo-search/models/TdoSearchEvent';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { TdoTableRowModel } from 'src/app/tdo-controls/common/tdo-table-v2/models/tdo-table-row.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConversionUtilities } from 'src/app/utilities/conversion.utilities';
import { UiService } from 'src/app/services/ui.service';
@Component({
  standalone: false,
  selector: 'app-referrer-portal-home',
  templateUrl: './referrer-portal-home.component.html',
  styleUrls: ['./referrer-portal-home.component.css']
})
export class ReferrerPortalHomeComponent implements OnInit, OnDestroy {
  @ViewChild('referralsTable') referralsTable: TdoTableV2Component;

  isLoading: boolean = true;
  referrerInformation: any = {};
  referrerId: string;

  patientEmail: string;
  patientAddress: string;

  referralsInfo: ReferralDataModel[] = [];
  selectedReferral: ReferralDataModel;
  searchPredicate: (data: any, filter: string) => boolean;
  datePickerStart: Date | null = new Date();
  datePickerEnd: Date | null = new Date();
  searchText: string ='';
  private endOfDayDate: Date = new Date();
  minSearchDate: Date = new Date(1900, 0, 1);
  maxSearchDate: Date = new Date();
  isMobile: boolean = false;
  isTablet: boolean = false;
  private destroy$ = new Subject<void>();
  isHandsetOrTablet: boolean;
  private destroyed = false;
  // CL-618/CL-621 follow-up magic link deep link - see ngOnInit/init.
  private deepLinkAppointmentId: string = null;
  private deepLinkPatientCaseId: string = null;
  deepLinkDocumentId: string = null;
  // tdo-table-v2's isAutoSelectFirstItem re-runs on a setTimeout after the initial render and
  // would otherwise overwrite a deep-link-matched referral with whichever row happens to be
  // first in the list - disabled for the one load where we already picked the right referral.
  autoSelectFirstReferral = true;

  constructor(
    private readonly staticDataService: StaticDataService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly referrerPortalService: ReferrerPortalService,
    private readonly uiService: UiService,
    private readonly breakpointObserver: BreakpointObserver,
    private readonly ngZone: NgZone,
    private readonly cdr: ChangeDetectorRef,
  ) {
    this.referrerInformation = JSON.parse(localStorage.getItem('storedReferrerUser'));
    this.referrerId = this.referrerInformation.authdata.doctorId;
    this.updateEndOfDay();
    this.searchPredicate = (dataSearch: TdoTableRowModel, filter: string) => {
      const rowCreated = this.normalizeXauditCreatedOn(dataSearch.model.xauditCreatedOn);
      // console.log("searchPredicate dataSearch.model.xauditCreatedOn:", dataSearch.model.xauditCreatedOn);
      //entrytext will contain all fields to search in
      const entryText = dataSearch.model.Patient_FirstName + ' ' + dataSearch.model.Patient_MidName + ' ' + dataSearch.model.Patient_LastName + ' '
            + dataSearch.model.Patient_Email + ' ' + dataSearch.model.Patient_Phone;
      return entryText.toLowerCase().includes(this.searchText.toLowerCase()) 
          && (this.datePickerStart == null || rowCreated >= this.datePickerStart) 
          && (this.datePickerEnd == null|| rowCreated <= this.endOfDayDate);
    };
  }

  ngOnInit() {

    this.datePickerStart = null;
    this.isLoading = true;

    // CL-618/CL-621 follow-up: a "Send Link to Doctor Only" magic-link email carries these so
    // the referring doctor lands directly on the specific document's viewer instead of just the
    // generic referrer portal home - consumed once below, in init(), after referralsInfo loads.
    const queryParams = this.route.snapshot.queryParamMap;
    this.deepLinkAppointmentId = queryParams.get('appointmentId');
    this.deepLinkPatientCaseId = queryParams.get('patientCaseId');
    this.deepLinkDocumentId = queryParams.get('documentId');
    // TEMP DIAGNOSTIC (CL-621 "document not appearing" investigation) - remove once root cause is confirmed.
    console.log('[CL-621] ReferrerPortalHomeComponent ngOnInit deep-link params:',
      'appointmentId=', this.deepLinkAppointmentId, 'patientCaseId=', this.deepLinkPatientCaseId, 'documentId=', this.deepLinkDocumentId);

    // Set up responsive breakpoint observer
    this.breakpointObserver.observe([Breakpoints.Handset, Breakpoints.Tablet])
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        this.isMobile = this.breakpointObserver.isMatched(Breakpoints.Handset);
        this.isTablet = this.breakpointObserver.isMatched(Breakpoints.Tablet);
        this.isHandsetOrTablet = this.isMobile || this.isTablet;        
      });

    if (!this.staticDataService.isReady) {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.init();

        }
      });
      // console.log('ReferrerPortalHomeComponent ngOnInit refreshValues');
      this.staticDataService.refreshValues();
    }
    else
      this.init();

  }

  init() {
    // add QR code icon that opens check in
    // create a new 'confirm appointment' page
    // disable confirm if already confirmed
    var promises = [
      this.getReferrals(this.referrerId),
      //   this.getPatientAppointments(),
    ];

    this.isLoading = true;

    Promise.all(promises).then((results: any[]) => {
      this.ngZone.run(() => {
        var refs: ReferralDataModel[] = results[0];
        refs.forEach(referral => {
          referral.StatusName = this.staticDataService.getValidValueItemByItemId(referral.enumReferralStatusID)?.ItemDisplayValue;
          if (referral.DiscomfortLevel)
            referral.DiscomfortLevelDescription = DiscomfortLevelList[referral.DiscomfortLevel].value;
        });
        this.referralsInfo = refs;

        // CL-618/CL-621 follow-up: auto-select the referral matching the emailed magic link's
        // appointmentId/patientCaseId, so ReferrerPortalReferralDetailComponent loads and can
        // auto-open deepLinkDocumentId once its reports finish loading (see that component's
        // GetReferreralReports). Cleared either way - it's a one-shot instruction for this
        // load, not something later interactions should keep re-triggering.
        //
        // Not r.AppointmentID (the ReferralDataModel-declared field, capital D) - the backend's
        // GetReferrals actually serializes this as "AppointmentId" (lowercase d,
        // TDOReferrerDoctorManager.cs/dataReferralDTO), and since this response is cast straight
        // into ReferralDataModel[] with no runtime remapping, r.AppointmentID is undefined on
        // every row - the match could never succeed. Reading the raw property name instead.
        //
        // patientCaseId is also matched (against r.ReferralID, which IS the PatientCaseId for a
        // case-based referral - TDOReferrerDoctorManager.cs sets ReferralID = PatientCaseId and
        // leaves AppointmentId null for those rows) because GenerateReferrerDocumentToken's
        // appointmentId can, in some cases, resolve to an appointment that isn't actually tied to
        // this referring doctor and so never matches any row the portal itself shows for them -
        // patientCaseId always matches the real referral row and is checked first.
        if (this.deepLinkPatientCaseId || this.deepLinkAppointmentId) {
          const match = refs.find(r => r.ReferralID === this.deepLinkPatientCaseId
            || (r as any).AppointmentId === this.deepLinkAppointmentId);
          if (match) {
            this.selectedReferral = match;
            this.autoSelectFirstReferral = false;
          }
          this.deepLinkPatientCaseId = null;
          this.deepLinkAppointmentId = null;
        }

        this.isLoading = false;
        if (!this.destroyed) {
          this.cdr.detectChanges();
          setTimeout(() => this.applySearch(), 0);
        }
      });
    }, err => {
      this.ngZone.run(() => {
        this.displayMessage('Error', 'Error retrieving the referral records.');
        this.isLoading = false;
        if (!this.destroyed) {
          this.cdr.detectChanges();
        }
      });
    });

  }

  getFormatedTime(hour: number, minutes: number) {
    var timePeriod = 'am';
    if (hour >= 12) {
      timePeriod = 'pm';
    }

    if (hour > 12) {
      hour = hour - 12;
    }

    var newMinutes = ''

    if (minutes < 10) {
      newMinutes = `0${minutes}`;
    } else {
      newMinutes = `${minutes}`;
    }

    return `${hour}:${newMinutes}${timePeriod}`
  }

  getReferrals(referrerId: string) {
    let promise = new Promise((resolve, reject) => {
      this.referrerPortalService.getReferrerals(referrerId)
        .subscribe(resolve, reject);
    });
    return promise;
  }
  // Handle selection and deselection of rows model data
  onRowSelected(event: TdoTableSelectionEvent) {
    this.selectedReferral = event.model;
  }

  editProfilePressed() {
    this.router.navigate(['/patientportal/profile']);
  }

  navigateToForm(task) {
    this.router.navigate([`/patientportal/form/${task.CaseWorkItemFormsId}`])
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  onSearchDateChange(event: MatDatepickerInputEvent<Date, Date | null>) {
    // console.log("OnSearchDateChange: ", event);
    this.applySearch();
  }

  displayMessage(type, message) {
    this.uiService.displayMessage(type, message);
  }

  

  onSearchInput(event) {
    this.applySearch();
  }

  onClearSearch() {
    this.searchText = '';
    this.applySearch();

  }

  onTextSearch(event: string) {
    this.applySearch();
  }
  applySearchFilter(event: TdoSearchEvent): void {
    this.searchText = event.value.toLocaleLowerCase();
    this.applySearch();
  }

  applySearch(){
    this.updateEndOfDay();
    if (this.datePickerStart && this.datePickerEnd && this.datePickerStart > this.endOfDayDate) {
      this.displayMessage('Error', 'Start date must be on or before end date.');
      return;
    }
    // MatTableDataSource skips the predicate when filter is an empty string, so pass a
    // sentinel space when searchText is empty. Safe because isSearchable="false" hides
    // the internal search box, and the predicate reads searchText from the component.
    // console.log("Apply Search:", this.searchText);
    const ev = new TdoSearchEvent(this.searchText || ' ');
    this.referralsTable.applySearchFilter(ev);
  }

  private updateEndOfDay() {
    if (this.datePickerEnd == null) {
      return;
    }
    this.endOfDayDate = new Date(this.datePickerEnd);
    this.endOfDayDate.setHours(23, 59, 59, 999);
  }

  closeDetailView() {
    this.selectedReferral = null;
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent) {
    if (this.isHandsetOrTablet && this.selectedReferral) {
      this.closeDetailView();
    }
  }

  ngOnDestroy() {
    this.destroyed = true;
    this.destroy$.next();
    this.destroy$.complete();
  }

  /** Normalize xauditCreatedOn to a Date; only append Z when value is a string without timezone. */
  private normalizeXauditCreatedOn(value: string | Date): Date {
    if (value instanceof Date) {
      return value;
    }
    if (typeof value === 'string') {
      const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/.test(value.trimEnd());
      return new Date(hasTimezone ? value : value + 'Z');
    }
    return new Date(value);
  }

  getDate(xauditCreatedOn: Date) {
    const d = new Date(xauditCreatedOn);
    return ConversionUtilities.convertUTCDateToLocalDateFromString(d.toLocaleString());
  }
}
